type SelectableDocument={
  id:string;original_file_name:string;processing_status:string;
  classification_review_status?:string;classification_proposal_id?:string;
  confirmed_development_id?:string|null;property_link_valid?:boolean;
  primary_scan_verdict:string;scan_verdict:string;draft_version?:number;
  critical_conflicts?:string[];
};
export const canSelectForFiling=(item:SelectableDocument)=>
  item.processing_status==='Review required'&&item.classification_review_status==='Awaiting review'&&
  Boolean(item.classification_proposal_id&&item.confirmed_development_id)&&
  item.property_link_valid!==false&&item.primary_scan_verdict==='Clean'&&item.scan_verdict!=='Quarantined'&&
  !item.draft_version&&!item.critical_conflicts?.length;

type Selection={selected:string[];onChange:(ids:string[])=>void;busy:boolean};
export function DocumentBatchCheckbox({item,selected,onChange,busy}:Selection&{item:SelectableDocument}){
  return <label className="batch-filing-choice">
    <input type="checkbox" aria-label={`Select ${item.original_file_name}`} checked={selected.includes(item.id)}
      disabled={busy||!canSelectForFiling(item)}
      onChange={event=>onChange(event.target.checked?[...new Set([...selected,item.id])]:selected.filter(id=>id!==item.id))}/>
    <strong>{item.original_file_name}</strong>
  </label>;
}
export function DocumentBatchSelection({rows,selected,onChange,busy,onPreview}:Selection&{rows:SelectableDocument[];onPreview:()=>void}){
  const eligible=rows.filter(canSelectForFiling).map(item=>item.id);
  return <section className="panel batch-filing-selection" aria-label="Batch filing">
    <p>Select documents with the same building and filing category. Preview checks confidence, conflicts and saved drafts before allowing filing.</p>
    <div className="actions">
      <label className="batch-filing-choice"><input type="checkbox" disabled={busy||!eligible.length}
        checked={eligible.length>0&&eligible.every(id=>selected.includes(id))}
        onChange={event=>onChange(event.target.checked?eligible:[])}/>Select eligible documents on this page</label>
      <span role="status">{selected.length} selected</span>
      <button disabled={busy||!selected.length} onClick={onPreview}>Preview filing selected documents</button>
    </div>
  </section>;
}
